import { types } from "./types/types";


const initialState = {
    loadingUiPago: false,
    completado: false
}

export const ui = (state = initialState, action) => {
    switch (action.type) {
        case types.startloadingUIPago:
            return {
                ...state,
                loadingUiPago: true
            }
        case types.finishloadingUIPago:
            return {
                ...state,
                loadingUiPago: false
            }
        // completado
        case types.setCompletado:
            return {
                ...state,
                completado: action.payload
            }

        default:
            return state;
    }
}